import React from 'react';
import './videoProject.css'; // Ensure this CSS file is imported

const VideoProject = () => {
    return (
        <section className='videoProjectSection'>
            <div className='videoProjectSectionLeft'>
                <iframe 
                    src="https://www.youtube-nocookie.com/embed/hPwqqeIvQSw?si=37VWd4RkXdaVH-mK&amp;start=1" 
                    title="YouTube video player" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay controlled clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    allowFullScreen
                ></iframe>
            </div>
            <div className='videoProjectSectionRight'>
                <h2>Precision PID Ball and Beam Control System</h2>
                <p>
                    In this project, we developed a sophisticated PID Ball and Beam Controller that enables precise control over a ball's position along a beam. By setting a specific target location, the system utilizes an ultrasonic sensor to continuously monitor the ball's position, while a rotor adjusts the beam to align the ball with the designated point. Additionally, the controller features an innovative "Obey Mode," which mirrors the position of a ball on an adjacent beam, dynamically tracking its movement in real-time. This dual functionality enhances the system's responsiveness and demonstrates practical applications in automated control and real-time tracking systems.
                </p>
            </div>
        </section>
    );
}

export default VideoProject;
